import { createReducer, on } from '@ngrx/store';
import * as WidgetActions from '../actions'
import { DatesAndAccupancy, HotelBookingData, ImagesData, Proposition, WidgetData } from '../index.types';
import { TranslationObject } from '@ngx-translate/core';
import * as _ from 'lodash';

export const FeatureKey = 'widget';

type Loaders = {
    engines: boolean,
    proposition: boolean
};

export interface WidgetState {
    datesAndAccupancy: DatesAndAccupancy | null,
    translations: TranslationObject,
    widgetData: WidgetData | null,
    comments: any | null,
    hotelBookingData: Record<string, HotelBookingData> | null,
    loaders: Loaders,
    noAvailability: boolean | null,
    proposition: Proposition[],
    imagesData: ImagesData | null,
    searchPanelVisibility: boolean,
    expanded: boolean
}

export const InitialWidgetState: WidgetState = {
    datesAndAccupancy: null,
    translations: [],
    widgetData: null,
    comments: null,
    hotelBookingData: null,
    loaders: {
        engines: false,
        proposition: false
    },
    noAvailability: null,
    proposition: [],
    imagesData: null,
    searchPanelVisibility: false,
    expanded: false
};

export const WidgetReducer = createReducer(
    InitialWidgetState,
    on(WidgetActions.DatesAndAccupancySubmitted, (state, {datesAndAccupancy})=> ({...state, datesAndAccupancy, hotelBookingData: null, loaders: {...state.loaders, engines: true}})),
    on(WidgetActions.WidgetDataLoaded, (state, {data})=> ({...state, widgetData: data})),
    on(WidgetActions.TranslationLoaded, (state, {translations})=> ({...state, translations})),
    on(WidgetActions.CommentsLoaded, (state, {comments})=> {
        const _comments    = _.cloneDeep(comments)
        const booking      = _.values(_comments.booking);
        const TripAdvisor  = _.values(_comments.TripAdvisor);      
        return {...state, comments: _.flatten([...booking, ...TripAdvisor]) }
    }),
    on(WidgetActions.HotelBookingDataLoaded, (state, {hotelBookingData})=> ({...state, hotelBookingData: {...state.hotelBookingData, ...hotelBookingData}})),
    on(WidgetActions.HotelBookingDataRequestEnds, (state)=> ({...state, loaders: {...state.loaders, engines: false}})),
    on(WidgetActions.HotelBookingDataRequested, (state)=> ({...state, noAvailability: null})),
    on(WidgetActions.PropositionRequested, (state)=> ({...state, noAvailability: true})),
    on(WidgetActions.PropositionRequested, (state)=> ({...state, proposition: [], loaders: {...state.loaders, proposition: true}})),
    on(WidgetActions.PropositionLoaded, (state, {proposition})=> ({...state, proposition, loaders: {...state.loaders, proposition: false}})),
    on(WidgetActions.ImagesDataLoaded, (state, {imagesData})=> ({...state, imagesData})),
    on(WidgetActions.UpdateSearchPanelVisibility, (state, {open})=> ({...state, searchPanelVisibility: open})),
    on(WidgetActions.Minimize, (state)=> ({...state, expanded: false})),
    on(WidgetActions.Maximize, (state)=> ({...state, expanded: true})),
);
